import { render, staticRenderFns } from "./SuperTagHelperDashBoard.vue?vue&type=template&id=fc3cae46&functional=true&"
import script from "./SuperTagHelperDashBoard.vue?vue&type=script&lang=js&"
export * from "./SuperTagHelperDashBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports